// import React, { useState } from "react";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import { apiEndpoints } from "../../config";

import PostSingle from "../../partials/posts/postSingle";
import { postNode } from "../../core/postNode";
import { getOnlineNode } from "../../core/getNode";
import AlertModal from "../../partials/alertModal";

import { Typography, Button, Alert } from "@mui/material";

export default function TrainingSingle(props) {
  const [fieldReferences, setFieldReferences] = useState([]);
  const [submission, setSubmission] = useState(null);
  const [post, setPost] = useState(null);
  const [sectionCompletion, setSectionCompletion] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const user = useSelector((state) => state).authReducer.user;

  const handleSectionComplete = useCallback((blockId, isComplete) => {
    setSectionCompletion((prev) => ({ ...prev, [blockId]: isComplete }));
  }, []);

  const allSectionsComplete =
    Object.keys(sectionCompletion).length > 0 &&
    Object.values(sectionCompletion).every(Boolean);
  useEffect(() => {
    console.log("fieldReferences", fieldReferences);
  }, [fieldReferences]);

  useEffect(() => {
    getSubmission();
    // eslint-disable-next-line
  }, [post]);

  const submitTraining = () => {
    if (post) {
      const data = {
        training_id: post?.id,
        field_references: fieldReferences
          .flatMap((e) => e.opened)
          .map((f) => ({ bundle: f.bundle, id: f.id })),
      };

      console.log("postData", data);

      postNode(apiEndpoints.trainingSubmission, data, user.csrf_token)
        .then((response) => {
          setSubmission(response);
          console.log("training response", response.data);
        })
        .catch((err) => {
          console.error("submit training error", err);
        });
    }
  };

  const getSubmission = () => {
    if (post) {
      getOnlineNode(
        `${apiEndpoints.trainingSubmission}?training_id=${post.id}&uid=${user.current_user.uid}?_format=json`,
      )
        .then((response) => {
          setSubmission(response.data);
          console.log("getSubmission response", response);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.training}
      featuredImageEnabled={true}
      entityFavoritesContentType={"training"}
      previewReturnRoute={"/training-creator"}
      returnRoute={"/training"}
      backBtnText={"Training Library"}
      screenClassName={"training"}
      v2Bundle={"training"}
      logCustomEventType={"training"}
      entityType={"training"}
      disableReactions={true}
      setFieldReferences={(finished) => setFieldReferences(finished)}
      trainingEntitySubmission={submission}
      setEntityPost={(_post) => {
        console.log("post", _post);
        setPost(_post);
      }}
      onComplete={handleSectionComplete}
      childrenAfter={
        <>
          {post && submission === null && (
            <Button
              disabled={!allSectionsComplete}
              variant="contained"
              onClick={() => {
                setShowConfirmation(true);
              }}
            >
              <Typography owner="client" variant="button" singles={true}>
                Submit
              </Typography>
            </Button>
          )}
        </>
      }
    >
      {submission && (
        <Alert
          className="ps-4"
          owner="client"
          severity="success"
          sx={{
            "& .MuiAlert-icon": {
              padding: "7px 0px 7px 9px",
            },
          }}
        >
          <Typography owner="client" variant="body1" weight="light">
            You have completed the quiz
          </Typography>
        </Alert>
      )}

      <AlertModal
        warningIcon
        showAlert={showConfirmation}
        alertMessageTitle={`Sign off`}
        alertMessageBody={
          "By submitting you are confirming that you have read and understood all the information in the course."
        }
        showAlertCallback={setShowConfirmation}
        confirmButton={true}
        confirmButtonLabel={"Submit"}
        onConfirm={() => {
          submitTraining();
        }}
        cancelButton={true}
      />
    </PostSingle>
  );
}
